import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Toast/ToastAnatomy.mdx";
import Usage from "../../Docs/Components/Toast/ToastUsage.mdx";

import Examples from "../../Docs/Components/Toast/ToastExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Toast"
            description="A toast notification is a non modal, unobtrusive component used to display brief, auto-expiring information."
            apiSources={["azure-devops-ui/Components/Toast/Toast.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/MQwjeE1w88guLumiUSuiWspT/Notifications?node-id=0%3A1"}}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;